import React from 'react';

import AfterDoc from '@/components/ui/AfterDoc';
import { PRODUCT } from '@/consts';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const ThankYouNotQualifyFixCostEnough = () => {
  const { i18n } = useLingui();

  return (
    <AfterDoc
      consultant={CONSULTANTS.MARTA_ASSISTANT}
      thankYouMessage={i18n.t(
        'Niestety, nie możemy podjąć dalszych działań w Twojej sprawie'
      )}
      withButton
      productId={PRODUCT.HOUSE_HOLD}
    >
      <div>
        <p className="body pb-2">
          {i18n.t(
            'Pomagamy naszym Klientom w odzyskaniu należnego odszkodowania, gdy ubezpieczyciel wypłacił zaniżoną kwotę, niewystarczającą na pokrycie rzeczywistych strat.'
          )}
        </p>
        <p className="body">
          {i18n.t(
            'W Twoim przypadku, zgodnie z decyzją ubezpieczyciela, wypłacone odszkodowanie wystarczyło na przywrócenie nieruchomości do stanu sprzed szkody. W takiej sytuacji nie ma podstaw do dalszego dochodzenia roszczeń.'
          )}
        </p>
      </div>
      <p className="body font-semibold">
        {i18n.t('W przypadku pytań zapraszamy do kontaktu.')}
      </p>
    </AfterDoc>
  );
};

export default ThankYouNotQualifyFixCostEnough;
